module.exports = {
    CHECKLIST: [
        'Ensure safety measures',
        'Check equipment handling and maintenance',
        'Comply with health and hygiene regulations',
        'Check food preparation and handling',
        'Look at the food presentation',
    ],
    ADDRESS_TYPES: [
        { value: "0", label: "-----Select-----" },
        { value: "1", label: "Assisted Living Facility" },
        { value: "2", label: "Community Mental Health Center" },
        { value: "3", label: "Comprehensive Outpatient Rehab Facility" },
        { value: "4", label: "Group Home" },
        { value: "5", label: "Home/Residence" },
        { value: "6", label: "Independent Clinic" },
        { value: "7", label: "Medical Facility" },
        { value: "8", label: "Other Place of Service" },
        { value: "9", label: "Outpatient" },
        { value: "10", label: "Relative's or Friend's Residence" },
        { value: "11", label: "School" },
        { value: "12", label: "Seasonal Residence" },
        { value: "13", label: "Unknown" },
        { value: "14", label: "Work/Office" },
        { value: "15", label: "Adult Day Healthcare Facility" },
        { value: "16", label: "Vehicle" },
        { value: "17", label: "Telemedicine for COVID-19" },
        { value: "18", label: "Community" },
        { value: "19", label: "Family Home" },
        { value: "20", label: "Member Home" },
        { value: "21", label: "Neighbor Home" },
        { value: "22", label: "Unknown" },
        { value: "23", label: "Walk-in Retail Health Clinic" }
    ],
    claimFilingIndicators: [
        { id: 1, value: '09-Self-pay' },
        { id: 2, value: '11-Other Non-Federal Programs' },
        { id: 3, value: '12-Preferred Provider Organization (PPO)' },
        { id: 4, value: '14-Exclusive Provider Organization (EPO)' },
        { id: 5, value: '15-Indemnity Insurance' },
        { id: 6, value: '16-Health Maintenance Organization (HMO) Medicare Risk' },
        { id: 7, value: 'BL-Blue Cross/Blue Shield' },
        { id: 8, value: 'CH-CHAMPUS' },
        { id: 9, value: 'CI-Commercial Insurance Co.' },
        { id: 10, value: 'HM-Health Maintenance Organization' },
        { id: 11, value: 'MA-Medicare Part A' },
        { id: 12, value: 'MB-Medicare Part B' },
        { id: 13, value: 'MC-Medicaid' },
        { id: 14, value: 'OF-Other Federal Program' },
        { id: 15, value: 'VA-Veterans Affairs Plan' },
        { id: 16, value: 'WC-Workers\' Compensation Health Claim' },
    ],
    interchangeIDQualifiers: [
        { id: 1, value: '01-Duns (Dun & Bradstreet)' },
        { id: 2, value: '14-Duns Plus Suffix' },
        { id: 3, value: '20-Health Industry Number(HIN)' },
        { id: 4, value: '27-Carrier Identification Number as assigned by Health Care Financing Administration(HCFA)' },
        { id: 5, value: '28-Fiscal Intermediary Identification Number as assigned by Health Care Financing Administration(HCFA)' },
        { id: 6, value: '29-Medicare Provider and Supplier Identification Number as assigned by Health Care Financing Administration(HCFA)' },
        { id: 7, value: '30-U.S. Federal Tax Identification Number' },
        { id: 8, value: '33-National Association of Insurance Commissioners Company Code(NAIC)' },
        { id: 9, value: 'ZZ-Mutually Defined' },
    ]

}